export default function (Component) {
      Component.options.__docs = "TODO: This is the documentation for SearchBox.\nTODO: 두번째줄.."
    }